import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Reports access guard. Replaces the legacy in-render
 * `alert('not authorized') + window.history.back()` (which mutated
 * history during render and broke the React lifecycle).
 *
 * Checks localStorage.accessReports; on denial, redirects to the 403
 * page from an effect (post-render, side-effect safe). Returns whether
 * access is granted so the caller can render null while redirecting.
 */
const useReportAccess = () => {
    const navigate = useNavigate();
    const [allowed] = useState(() => localStorage.getItem('accessReports') === '1');

    useEffect(() => {
        if (!allowed) {
            navigate(`${process.env.PUBLIC_URL}/pages/errors/error403/default`, { replace: true });
        }
    }, [allowed, navigate]);

    return allowed;
};

export default useReportAccess;
